import * as Yup from "yup";
import { validarCuilCuit } from "../../../util/cuilcuit";

const ResponsablesEnum = Object.freeze({
  1: "1 - Responsable de Seguridad e Higiene",
  3: "2 - Representante de Medicina Laboral",
  4: "3 - Contacto Empresa",
  2: "3 - Representante Empleador"
})

export const esSeguridadOMedicina = (nombreCargoEmpresa) => {
  if (nombreCargoEmpresa) {
    return '1' === nombreCargoEmpresa.slice(0, 1) || nombreCargoEmpresa.slice(0, 1) === '2'
  }
  return false;
}

export const validateNewResponsable = Yup.object({
  cargoEmpresa: Yup.string().nullable().required("Campo obligatorio"),
  apellido: Yup.string()
    .max(50, "Máximo 50 caracteres")
    .required("Campo obligatorio"),
  nombres: Yup.string()
    .matches(/^[a-zA-Z\s]+$/, "Ingrese sólo letras y espacios")
    .max(50, "Máximo 50 caracteres")
    .optional(),
  cuit: Yup.string()
    .matches(/^\d{11}$/, "El CUIL/CUIT debe contener 11 dígitos numéricos")
    .required("Campo obligatorio")
    .test({
      name: "cuitValido",
      message: "Debe ingresar un CUIT/CUIL válido",
      test: function (value) {
        if (value) {
          return validarCuilCuit(value, true);
        }
      },
    }),
  tipoDocumento: Yup.string().nullable(),
  numeroDocumento: Yup.string()
    .min(7, "Mínimo 7 dígitos")
    .max(8, "Máximo 8 dígitos")
    .matches(/^\d+$/, "No ingrese caracteres especiales")
    .nullable(),
  telefono: Yup.string()
    .matches(
      /^[0-9()+-\s]*$/,
      "Solo se permiten números y los caracteres ( ) + - y espacio"
    )
    .max(50, "El número de teléfono debe tener como máximo 50 caracteres")
    .optional(),
  email: Yup.string()
    .max(255, "Máximo 255 caracteres")
    .email("Ingrese una dirección de correo válida")
    .optional(),
  tipoMatricula: Yup.number().nullable().when('nombreCargoEmpresa', {
    is: esSeguridadOMedicina,
    then: (schema) => schema.required("Campo obligatorio"),
  }),
  nroMatricula: Yup.string()
    .max(50, "Máximo 50 caracteres")
    .matches(/^\d*$/, "Ingrese sólo números")
    .when('nombreCargoEmpresa', {
      is: esSeguridadOMedicina,
      then: (schema) => schema.required("Campo obligatorio"),
    }),
  horasAsignadas: Yup.number("Sólo se permiten números")
    .max(8760, "Máximo 8760 horas")
    .positive("Ingrese números positivos")
    .integer("No ingrese caracteres especiales")
    .nullable()
    .typeError("Ingrese sólo números"),
  titulo: Yup.string()
    .matches(/^[a-zA-Z\s]+$/, "Ingrese sólo letras y espacios")
    .max(100, "Máximo 100 caracteres")
    .optional(),
  matriculaOtorgadaPor: Yup.string()
    .matches(/^[a-zA-Z\s]+$/, "Ingrese sólo letras y espacios")
    .max(100, "Máximo 100 caracteres")
    .when('nombreCargoEmpresa', {
      is: esSeguridadOMedicina,
      then: (schema) => schema.required("Campo obligatorio"),
    }),
});
